import React from "react";
import { Link, useLocation } from "react-router-dom";
import { LayoutGrid } from "lucide-react";
import { useAuth } from "../context/AuthContext";

/**
 * Sticky "Back to dashboard" pill rendered on every protected inner route.
 *
 * Visibility rules:
 *   - hidden for logged-out users / on auth + public/marketing pages
 *   - hidden on the dashboard itself
 *   - hidden on the Studio (it already has its own back link)
 *   - sits in the bottom-left so it never collides with the floating
 *     Feedback button (which lives bottom-right).
 */
const HIDDEN_PATHS = [
  "/",          // dashboard
  "/welcome",
  "/login",
  "/register",
  "/gate",
  "/beta",
  "/beta-guide",
];

function isHidden(pathname) {
  if (HIDDEN_PATHS.includes(pathname)) return true;
  if (pathname.startsWith("/share/")) return true;
  if (pathname.startsWith("/role/")) return true;
  return false;
}

export default function BackToDashboard() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  if (!user || user === false) return null;
  if (isHidden(pathname)) return null;

  return (
    <Link
      to="/"
      className="fixed z-30 inline-flex items-center gap-2 font-mono-rm text-[11px] uppercase tracking-widest px-3.5 py-2.5 transition-transform hover:-translate-y-0.5"
      style={{
        right: 20,
        bottom: 70,
        background: "#0F1B2D",
        color: "#FFC145",
        border: "2px solid #0F1B2D",
        borderRadius: 999,
        fontWeight: 700,
        boxShadow: "4px 4px 0 0 #FF6A00",
      }}
      data-testid="back-to-dashboard-btn"
      title="Back to dashboard"
    >
      <LayoutGrid size={13} />
      Back to dashboard
    </Link>
  );
}
